import { AZIMUT_URL, signatureAreaMessages, SignatureDocument, SignatureDocumentModule } from 'azshared';
import React, { Fragment, useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { SignatureAreaBaseDocumentModule } from './signature-area-base-document-module';
import { AppCheckbox } from '../../../../../components/checkbox/app-checkbox';
import { AppButton } from '../../../../../components/buttons/app-button';
import './signature-area-base-document-content.scss';
import { AppTooltip } from 'src/components/tooltip/tooltip';
import { AppSvgIcon } from 'src/components/svg-icon/app-svg-icon';

export const SignatureAreaBaseDocumentContent = (props: {
  document: SignatureDocument;
  isLoadingRejectProposal: boolean;
  isLoadingGetUrlForSignature: boolean;
  openDetail: (moduleId: string, documentId: string) => void;
  startProcedure: (documentId: string) => void;
  rejectProposal: (documentId: string) => void;
  isProspect: boolean;
}) => {
  const { document, openDetail, startProcedure, rejectProposal, isLoadingGetUrlForSignature, isLoadingRejectProposal } = props;
  const [isSecondStep, setIsSecondStep] = useState(false);
  const [checked, setChecked] = useState(false);
  const [acknowledgmentChecked, setAcknowledgmentChecked] = useState(false);
  const { formatMessage } = useIntl();

  const handleClickForward = useCallback(() => {
    if (
      ((document.type?.practiceType === 'InvestmentProposal' && document.type?.proposalType === 'Advanced') ||
        document.type?.practiceType === 'MAX') &&
      !isSecondStep
    ) {
      setIsSecondStep(true);
      setChecked(false);
    } else {
      startProcedure(document.id);
    }
  }, [document, isSecondStep, startProcedure]);

  const handleClickRejected = useCallback(() => {
    rejectProposal(document.id);
  }, [document.id, rejectProposal]);

  const handleClickGoBack = useCallback(() => {
    setIsSecondStep(false);
    setChecked(true);
  }, [setIsSecondStep, setChecked]);

  const handleAcknowledgementChanged = useCallback(
    (value: boolean) => {
      setChecked(value);
    },
    [setChecked]
  );

  const handleProspectAcknowledgementChanged = useCallback((value: boolean) => {
    setAcknowledgmentChecked(value);
  }, []);

  return (
    <Fragment>
      {document?.modules?.map((item: SignatureDocumentModule, index) => (
        <SignatureAreaBaseDocumentModule
          key={item.title}
          isFirstModule={index === 0}
          document={document}
          module={item}
          openDetail={openDetail}
          clickGoBack={handleClickGoBack}
          clickGoForward={handleClickForward}
          clickRejected={handleClickRejected}
          isSecondStep={isSecondStep}
          acknowledgementChecked={checked}
          onAcknowledgementChanged={handleAcknowledgementChanged}
          isLoadingRejectProposal={isLoadingRejectProposal}
          isLoadingGetUrlForSignature={isLoadingGetUrlForSignature}
          isProspect={props.isProspect}
        />
      ))}
      {document.type?.practiceType === 'InvestmentProposal' && (
        <div className='signature-area-rto-disclaimer-footer'>
          {formatMessage(signatureAreaMessages.textFooterDisclaimer)}
          <a href={AZIMUT_URL} target='_blank' rel='noreferrer'>
            {formatMessage(signatureAreaMessages.linkFooterDisclaimer)}{' '}
          </a>
        </div>
      )}
      {props.isProspect && (
        <>
          <div className='signature-area-base-document-content-survery-summary-label signature-area-base-document-content-first-label'>
            {formatMessage(signatureAreaMessages.surverySummaryConsentTextA)}
          </div>
          <div className='signature-area-base-document-content-survery-summary-label signature-area-base-document-content-second-label'>
            {formatMessage(signatureAreaMessages.surverySummaryConsentTextB)}
          </div>
          <div className='signature-area-base-document-content-sign'>
            <AppTooltip title={formatMessage(signatureAreaMessages.cancelPracticeToastDescription)}>
              <p className='cancel-practice-info'>
                {formatMessage(signatureAreaMessages.cancelPracticeToastTitle)} <AppSvgIcon icon='information' />
              </p>
            </AppTooltip>
            <div>
              <AppCheckbox
                label={formatMessage(signatureAreaMessages.consentLabel)}
                checked={acknowledgmentChecked}
                onChange={handleProspectAcknowledgementChanged}
              />
              <AppButton onClick={handleClickForward} label={formatMessage(signatureAreaMessages.signLabel)} disabled={!acknowledgmentChecked} />
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
};
